import styled from 'styled-components';
import { useSelector } from 'react-redux';
import CopisaResidualImpactProbRiskElement from './CopisaResidualImpactProbRiskElement';
import colors from '../../../../../../../constants/colors';

export default function CopisaResidualImpactProbRiskBlock(props) {
  const { plantObligation } = props;
  const poLevel3 = useSelector(
    (state) => state.currentPage?.plantObligationLevels?.level3
  );

  return (
    <Container>
      <CopisaResidualImpactProbRiskElement
        type="imp"
        state={poLevel3?.[plantObligation]?.copisaPenaltyRisk?.residualImpact}
      />
      <CopisaResidualImpactProbRiskElement
        type="risk"
        state={
          Array.isArray(
            poLevel3?.[plantObligation]?.copisaPenaltyRisk?.residualReputation
          )
            ? poLevel3?.[plantObligation]?.copisaPenaltyRisk?.residualReputation
                ?.length * 20
            : poLevel3?.[plantObligation]?.copisaPenaltyRisk?.residualReputation
        }
      />
      <CopisaResidualImpactProbRiskElement
        type="prob"
        state={
          poLevel3?.[plantObligation]?.copisaPenaltyRisk?.residualProbability
        }
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
  color: ${colors.primary};
  justify-content: center;
`;
